import {
  SessionResultLabels,
  SessionSource,
  SessionSourceLabels,
  SessionTypeLabels,
  SessionTypeValues,
  StampedSessionSources,
} from '../../_models/session-enums';
import { ResolveLookupOutcomeLabels } from '../../_models/resolve';
import { TranMatchedStatus } from '../../_models/chargeback';
import {
  FilterInputType,
  FilterType,
  MultiOption,
  MultiOptions,
  MultiSubOption,
  MultiSubOptions,
} from '../../custom-multi-select/multi-select';
import { cloneDeep } from 'lodash';
import {
  CustomerJourneyDimensionGroup,
  CustomerJourneyIntentType,
  CustomerJourneyType,
  IdentificationStatusLabels,
  MomentLabels,
  PortalMomentColumn,
  PortalMomentColumnDef,
  ReportDimensions,
  ResolveLinkTypeLabels,
  TopIntentColumn,
  TopIntentColumnDef,
} from '../models/reports';
import { ProcessorType, ProcessorTypeLabels, GatewayTransactionStatus, GatewayTransactionStatusLabels, GatewayTransactionType, GatewayTransactionTypeLabels, GatewayCardType, GatewayCardTypeLabels } from '../../_models/checkout';
import { OfferIntents, OfferStages, abbrOfferStageLabel, BooleanFilterValue, JourneyIntentLabels } from '../../_models/funnel';

export const fields: MultiOptions = [
  {
    model: 'dimensions',
    label: 'Dimensions',
    selected: false,
    disabled: false,
    activeCount: 1,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      {
        model: 'product_path',
        label: 'Customer Stage',
        selected: false,
        disabled: false,
      },
      {
        model: 'product_name',
        label: 'Product Name',
        selected: false,
        disabled: false,
      },
      {
        model: 'step_name',
        label: 'Step Impressions',
        selected: false,
        disabled: false,
      },
      {
        model: 'cancel_reason',
        label: 'Cancel reason',
        selected: false,
        disabled: false,
      },
      {
        model: 'cancel_reason_category',
        label: 'Cancel Reason Category',
        selected: false,
        disabled: false,
      },
      {
        model: 'campaign_name',
        label: 'Brand',
        selected: false,
        disabled: false,
      },
      {
        model: 'input_name',
        label: 'Input Name',
        selected: false,
        disabled: false,
      },
      {
        model: 'crm_campaign_name',
        label: 'CRM campaign',
        selected: false,
        disabled: false,
      },
      {
        model: 'crm_campaign_id',
        label: 'CRM campaign ID',
        selected: false,
        disabled: false,
      },
      {
        model: 'campaign_product_id',
        label: 'Campaign product id',
        selected: false,
        disabled: false,
      },
      {
        model: 'username',
        label: 'Session ID',
        selected: false,
        disabled: false,
      },
      {
        model: 'customer_id',
        label: 'Customer ID',
        selected: false,
        disabled: false,
      },
      {
        model: 'order_id',
        label: 'Order ID',
        selected: false,
        disabled: false,
      },
      {
        model: 'device_type',
        label: 'Device Type',
        selected: false,
        disabled: false,
      },
      {
        model: 'crm_type',
        label: 'Platform',
        selected: false,
        disabled: false,
      },
    ],
  },
  {
    model: 'timeInterval',
    label: 'Time Interval',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: 'hour', label: 'Hours', selected: false, disabled: false },
      { model: 'week', label: 'Week', selected: false, disabled: false },
      { model: 'month', label: 'Month', selected: false, disabled: false },
      { model: 'year', label: 'Year', selected: false, disabled: false },
    ],
  },
  {
    model: 'statistics',
    label: 'Statistics',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      {
        model: 'item_refund_quantity',
        label: 'Refund quantity',
        selected: false,
        disabled: false,
      },
      {
        model: 'item_price',
        label: 'Total billed',
        selected: false,
        disabled: false,
      },
      {
        model: 'item_refund_amount',
        label: 'Refund amount',
        selected: false,
        disabled: false,
      },
      {
        model: 'item_partial_refund_amount',
        label: 'Partial refund amount',
        selected: false,
        disabled: false,
      },
      {
        model: 'item_full_refund_amount',
        label: 'Full refund amount',
        selected: false,
        disabled: false,
      },
      {
        model: 'customer_count',
        label: 'Customer Quantity',
        selected: false,
        disabled: false,
      },
      {
        model: 'orders_count',
        label: 'Orders',
        selected: false,
        disabled: false,
      },
    ],
  },
];

export const filters: MultiOptions = [
  {
    model: 'product_id',
    label: 'Products',
    selected: false,
    disabled: false,
    loading: true,
    activeCount: 0,
    options: [],
    pagination: true,
    type: 'DROPDOWN',
  },
  {
    model: 'product_path',
    label: 'Customer Stage',
    selected: false,
    disabled: false,
    loading: true,
    activeCount: 0,
    options: [],
    searchTerm: '',
    type: 'DROPDOWN',
  },
  {
    model: 'step_slug',
    label: 'Step Impressions',
    selected: false,
    disabled: false,
    loading: true,
    activeCount: 0,
    options: [],
    searchTerm: '',
    type: 'DROPDOWN',
  },
  {
    model: 'cancel_reason',
    label: 'Cancel Reason',
    selected: false,
    disabled: false,
    loading: true,
    activeCount: 0,
    options: [],
    searchTerm: '',
    type: 'DROPDOWN',
  },
  {
    model: 'input_name',
    label: 'Input Name',
    selected: false,
    disabled: false,
    loading: true,
    activeCount: 0,
    options: [],
    searchTerm: '',
    type: 'DROPDOWN',
  },
  {
    model: 'campaign_id',
    label: 'Brand',
    selected: false,
    disabled: false,
    loading: true,
    activeCount: 0,
    options: [],
    searchTerm: '',
    type: 'DROPDOWN',
  },
  {
    model: 'crm_campaign_id',
    label: 'CRM Campaign',
    selected: false,
    disabled: false,
    loading: true,
    activeCount: 0,
    options: [],
    searchTerm: '',
    type: 'DROPDOWN',
  },
  {
    model: 'cancel_reason_category',
    label: 'Cancel Reason Category',
    selected: false,
    disabled: false,
    loading: true,
    activeCount: 0,
    options: [],
    searchTerm: '',
    type: 'DROPDOWN',
  },
];

export const paymentUpdaterFields: MultiOptions = [
  {
    model: 'dimensions',
    label: 'Dimensions',
    selected: false,
    disabled: false,
    activeCount: 1,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      {
        model: 'username',
        label: 'Session ID',
        selected: false,
        disabled: false,
      },
      {
        model: 'source',
        label: 'Path channel',
        selected: false,
        disabled: false,
      },
      {
        model: 'tracking_source',
        label: 'Traffic source',
        selected: false,
        disabled: false,
      },
      {
        model: 'sid1',
        label: 'Source sub 1',
        selected: false,
        disabled: false,
      },
      {
        model: 'sid2',
        label: 'Source sub 2',
        selected: false,
        disabled: false,
      },
      {
        model: 'sid3',
        label: 'Source sub 3',
        selected: false,
        disabled: false,
      },
      {
        model: 'customer_name',
        label: 'Customer Name',
        selected: false,
        disabled: false,
      },
      {
        model: 'email',
        label: 'Customer Email',
        selected: false,
        disabled: false,
      },
      {
        model: 'phone',
        label: 'Customer Phone',
        selected: false,
        disabled: false,
      },
      {
        model: 'campaign_name',
        label: 'Brand',
        selected: false,
        disabled: false,
      },
      {
        model: 'error',
        label: 'Error Message',
        selected: false,
        disabled: false,
      },
      {
        model: 'note',
        label: 'CRM Note',
        selected: false,
        disabled: false,
      },
      {
        model: 'path_name',
        label: 'Path Name',
        selected: false,
        disabled: false,
      },
      {
        model: 'recording_url',
        label: 'Video Recording',
        selected: false,
        disabled: false,
      },
      {
        model: 'aff_id',
        label: 'Affiliate',
        selected: false,
        disabled: false,
      },
      {
        model: 'sub1',
        label: 'Aff sub 1',
        selected: false,
        disabled: false,
      },
      {
        model: 'sub2',
        label: 'Aff sub 2',
        selected: false,
        disabled: false,
      },
      {
        model: 'sub3',
        label: 'Aff sub 3',
        selected: false,
        disabled: false,
      },
      {
        model: 'country',
        label: 'Country',
        selected: false,
        disabled: false,
      },
      {
        model: 'device_type',
        label: 'Device type',
        selected: false,
        disabled: false,
      },
      {
        model: 'browser_name',
        label: 'Browser',
        selected: false,
        disabled: false,
      },
      {
        model: 'os_version',
        label: 'Device OS version',
        selected: false,
        disabled: false,
      },
      {
        model: 'mobile_vendor',
        label: 'Device brand',
        selected: false,
        disabled: false,
      },
      {
        model: 'mobile_model',
        label: 'Device model',
        selected: false,
        disabled: false,
      },
      {
        model: 'ip_address',
        label: 'IP Address',
        selected: false,
        disabled: false,
      },
      {
        model: 'action_result',
        label: 'Session Action Result',
        selected: false,
        disabled: false,
      },
      {
        model: 'result',
        label: 'Session result',
        selected: false,
        disabled: false,
      },
      {
        model: 'session_action_status',
        label: 'Session Action Status',
        selected: false,
        disabled: false,
      },
    ],
  },
  {
    model: 'statistics',
    label: 'Statistics',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      {
        model: 'session_count',
        label: 'Session Quantity',
        selected: false,
        disabled: false,
      },
      {
        model: 'customer_count',
        label: 'Customer Quantity',
        selected: false,
        disabled: false,
      },
      {
        model: 'failed_tries',
        label: 'Failed Tries',
        selected: false,
        disabled: false,
      },
    ],
  },
  {
    model: 'exclude',
    label: 'Exclude',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      {
        model: 'exclude_tests',
        label: 'Tests',
        selected: false,
        disabled: false,
      },
      {
        model: 'exclude_zeroes',
        label: 'All Zeroes',
        selected: false,
        disabled: false,
      },
    ],
  },
];

export const paymentUpdaterFilters: MultiOptions = [
  {
    model: 'campaign',
    label: 'Brand',
    selected: false,
    disabled: false,
    loading: true,
    activeCount: 0,
    type: 'DROPDOWN',
    options: [],
  },
  {
    model: 'tracking_source',
    label: 'Traffic source',
    selected: false,
    disabled: false,
    loading: true,
    activeCount: 0,
    type: 'DROPDOWN',
    options: [],
    pagination: true,
  },
  {
    model: 'source',
    label: 'Channel source',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    type: 'DROPDOWN',
    options: [
      { model: 'Web', label: 'Web', selected: false, disabled: false },
      { model: 'Email', label: 'Email', selected: false, disabled: false },
      { model: 'Phone', label: 'Phone', selected: false, disabled: false },
      {
        model: 'Social Media',
        label: 'Social Media',
        selected: false,
        disabled: false,
      },
    ],
    pagination: true,
  },
];

export const chargebackFields: MultiOptions = [
  {
    model: 'dimensions',
    label: 'Dimensions',
    selected: false,
    disabled: false,
    activeCount: 1,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      {
        model: 'affiliate',
        label: 'Affiliate',
        disabled: false,
      },
      { model: 'sub1', label: 'Aff sub 1', disabled: false },
      { model: 'sub2', label: 'Aff sub 2', disabled: false },
      { model: 'sub3', label: 'Aff sub 3', disabled: false },
      {
        model: 'alert_source',
        label: 'Alert Source',
        disabled: false,
      },
      {
        model: 'billing_cycle',
        label: 'Billing Cycle',
        disabled: false,
      },
      {
        model: 'campaign',
        label: 'Brand',
        disabled: false,
      },
      { model: 'card_bin', label: 'Card BIN', disabled: false },
      {
        model: 'card_type',
        label: 'Card Type',
        disabled: false,
      },
      {
        model: 'card_last4',
        label: 'Card Last 4',
        disabled: false,
      },
      {
        model: 'chargeback_date',
        label: 'Chargeback Date',
        disabled: false,
      },
      {
        model: 'crm_campaign',
        label: 'CRM campaign',
        disabled: false,
      },
      {
        model: 'customer_id',
        label: 'Customer ID',
        disabled: false,
      },
      {
        model: 'merchant_id',
        label: 'Merchant Processor',
        disabled: false,
      },
      {
        model: 'mid_number',
        label: 'MID number',
        disabled: false,
      },
      {
        model: 'payment_source',
        label: 'Payment Method',
        disabled: false,
      },
      {
        model: 'refund_date',
        label: 'Refund Date',
        disabled: false,
      },
      {
        model: 'request_type',
        label: 'Request Type',
        disabled: false,
      },
      {
        model: 'sp_session_id',
        label: 'Solvpath Session ID',
        disabled: false,
      },
      {
        model: 'sp_session_source',
        label: 'Session Source',
        disabled: false,
      },
      {
        model: 'matched_status',
        label: 'Solvpath Matched Type',
        disabled: false,
      },
      {
        model: 'amount',
        label: 'Transaction Amount',
        disabled: false,
      },
      {
        model: 'transaction_id',
        label: 'Transaction ID',
        disabled: false,
      },
      {
        model: 'created',
        label: 'Transaction Date',
        disabled: false,
      },
      {
        model: 'transaction_type',
        label: 'Transaction Type',
        disabled: false,
      },
    ],
  },
  {
    model: 'statistics',
    label: 'Statistics',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      {
        model: 'alert_ratio',
        label: 'Alert Ratio',
        disabled: false,
      },
      {
        model: 'chargeback_ratio',
        label: 'Chargeback Ratio',
        disabled: false,
      },
      {
        model: 'dispute_count',
        label: 'Dispute Count',
        disabled: false,
      },
      {
        model: 'dispute_ratio',
        label: 'Dispute Ratio',
        disabled: false,
      },
      {
        model: 'time_period',
        label: 'Time Period',
        disabled: false,
      },
    ],
  },
];

export const chargebackFilters: MultiOptions = [
  {
    model: 'alert_source',
    label: 'Alert Source',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    type: 'DROPDOWN',
    options: [
      {
        model: 0,
        label: 'NONE',
        disabled: false,
        selected: false,
      },
      {
        model: 1,
        label: 'ETHOCA',
        disabled: false,
        selected: false,
      },
      {
        model: 2,
        label: 'VERIFI',
        disabled: false,
        selected: false,
      },
      {
        model: 3,
        label: 'RDR',
        disabled: false,
        selected: false,
      },
      {
        model: 4,
        label: 'OTHER',
        disabled: false,
        selected: false,
      },
    ],
  },
  {
    model: 'billing_cycle',
    label: 'Billing Cycle',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    selectedOption: '',
    type: 'COMPARISON',
    options: [
      {
        model: 'e',
        label: 'Equals to',
        disabled: false,
        selected: false,
      },
      {
        model: 'gt',
        label: 'Greater than',
        disabled: false,
        selected: false,
      },
      {
        model: 'gte',
        label: 'Greater than or equals to',
        disabled: false,
        selected: false,
      },
      {
        model: 'lt',
        label: 'Less than',
        disabled: false,
        selected: false,
      },
      {
        model: 'lte',
        label: 'Less than or equals to',
        disabled: false,
        selected: false,
      },
      {
        model: 'range',
        label: 'Between',
        disabled: false,
        selected: false,
      },
    ],
  },
  {
    model: 'card_bin',
    label: 'Card Bin',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    inputType: 'number',
    placeholder: 'Please Enter Card Bin',
    type: 'INPUT',
  },
  {
    model: 'card_type',
    label: 'Card Type',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    type: 'DROPDOWN',
    options: [
      {
        model: 0,
        label: 'NONE',
        disabled: false,
        selected: false,
      },
      {
        model: 1,
        label: 'VISA',
        disabled: false,
        selected: false,
      },
      {
        model: 2,
        label: 'MASTERCARD',
        disabled: false,
        selected: false,
      },
      {
        model: 3,
        label: 'AMEX',
        disabled: false,
        selected: false,
      },
      {
        model: 4,
        label: 'DISCOVER',
        disabled: false,
        selected: false,
      },
      {
        model: 5,
        label: 'OTHER',
        disabled: false,
        selected: false,
      },
    ],
  },
  {
    model: 'card_last4',
    label: 'Card Last 4',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    inputType: 'number',
    placeholder: 'Please Enter Card Last 4',
    type: 'INPUT',
  },
  {
    model: 'campaign',
    label: 'Brand',
    selected: false,
    disabled: false,
    loading: true,
    activeCount: 0,
    options: [],
    searchTerm: '',
    type: 'DROPDOWN',
  },
  {
    model: 'crm_campaign',
    label: 'CRM Campaign',
    selected: false,
    disabled: false,
    loading: true,
    activeCount: 0,
    type: 'DROPDOWN',
  },
  {
    model: 'customer_email',
    label: 'Customer Email',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    inputType: 'text',
    placeholder: 'Please Enter Customer Email',
    type: 'INPUT',
  },
  {
    model: 'customer_id',
    label: 'Customer ID',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    inputType: 'number',
    placeholder: 'Please Enter Customer ID',
    type: 'INPUT',
  },
  {
    model: 'merchant_id',
    label: 'Merchant Processor',
    selected: false,
    disabled: false,
    loading: true,
    options: [],
    activeCount: 0,
    type: 'DROPDOWN',
  },
  {
    model: 'mid_number',
    label: 'MID Number',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    inputType: 'number',
    placeholder: 'Please Enter MID Number',
    type: 'INPUT',
  },
  {
    model: 'matched_status',
    label: 'Solvpath Matched Type',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    type: 'DROPDOWN',
    options: [
      {
        model: 0,
        label: 'No Match',
        disabled: false,
        selected: false,
      },
      {
        model: 1,
        label: 'Match By Customer',
        disabled: false,
        selected: false,
      },
      {
        model: 2,
        label: 'Match By Session',
        disabled: false,
        selected: false,
      },
      {
        model: 3,
        label: 'Match By Order',
        disabled: false,
        selected: false,
      },
    ],
  },
  {
    model: 'amount',
    label: 'Transaction Amount',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    selectedOption: '',
    type: 'COMPARISON',
    options: [
      {
        model: 'e',
        label: 'Equals to',

        disabled: false,
        selected: false,
      },
      {
        model: 'gt',
        label: 'Greater than',

        disabled: false,
        selected: false,
      },
      {
        model: 'gte',
        label: 'Greater than or equals to',

        disabled: false,
        selected: false,
      },
      {
        model: 'lt',
        label: 'Less than',

        disabled: false,
        selected: false,
      },
      {
        model: 'lte',
        label: 'Less than or equals to',

        disabled: false,
        selected: false,
      },
      {
        model: 'range',
        label: 'Between',

        disabled: false,
        selected: false,
      },
    ],
  },
  {
    model: 'transaction_id',
    label: 'Transaction ID',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    inputType: 'number',
    placeholder: 'Please Enter Transaction ID',
    type: 'INPUT',
  },
];

export const spTouchedFields: MultiOptions = cloneDeep(chargebackFields);
const dimensionsModel = spTouchedFields.find((field) => field.model === 'dimensions');

if (dimensionsModel) {
  (dimensionsModel.options as MultiSubOptions).push(
    { model: 'sp_session_path', label: 'Product Path', disabled: false },
    { model: 'sp_session_step', label: 'Step', disabled: false },
    { model: 'sp_session_status', label: 'Session Status', disabled: false },
    { model: 'sp_session_result', label: 'Session Result', disabled: false },
    { model: 'sp_session_latest_result', label: 'Latest Result', disabled: false },
    { model: 'sp_session_steps_count', label: 'Step Count', disabled: false }
  );
}

export const spTouchedFilters = {
  matched_status: [TranMatchedStatus.MatchByOrder, TranMatchedStatus.MatchBySession, TranMatchedStatus.MatchByCustomer],
};

export const ChatbotFields: MultiOptions = [
  {
    model: 'dimensions',
    label: 'Dimensions',
    selected: false,
    disabled: false,
    activeCount: 1,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      {
        model: 'customer_name',
        label: 'Name',
        selected: false,
        disabled: false,
      },
      {
        model: 'session_source',
        label: 'Session Source',
        selected: false,
        disabled: false,
      },
      {
        model: 'chatbot_session_id',
        label: 'Chatbot Session ID',
        selected: false,
        disabled: false,
      },
      {
        model: 'question_at',
        label: 'Q Time',
        selected: false,
        disabled: false,
      },
      {
        model: 'question',
        label: 'Question',
        selected: false,
        disabled: false,
      },
      {
        model: 'answer_at',
        label: 'A Time',
        selected: false,
        disabled: false,
      },
      {
        model: 'answer',
        label: 'Bot Answer',
        selected: false,
        disabled: false,
      },
      {
        model: 'intents',
        label: 'Intents',
        selected: false,
        disabled: false,
      },
      {
        model: 'sentiment',
        label: 'Sentiment',
        selected: false,
        disabled: false,
      },
      {
        model: 'threat_identified',
        label: 'Threat Identified',
        selected: false,
        disabled: false,
      },
    ],
  },
  {
    model: 'statistics',
    label: 'Statistics',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      {
        model: 'message_count',
        label: 'Message Count',
        selected: true,
        disabled: false,
      },
    ],
  },
];

export const ChatbotPopupFields = [
  'customer_name',
  'session_source',
  'chatbot_session_id',
  'exclude_zeroes',
  'question_at',
  'question',
  'answer_at',
  'answer',
  'is_success',
];

export const ChatbotFilters: MultiOptions = [
  {
    model: 'chatbot_session_id',
    label: 'Chatbot Session ID',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    inputType: 'number',
    placeholder: 'Please Enter Chatbot Session ID',
    type: 'INPUT',
  },
  {
    model: 'message_count',
    label: 'Message Count',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    selectedOption: '',
    type: 'COMPARISON',
    options: [
      {
        model: 'e',
        label: 'Equals to',
        disabled: false,
        selected: false,
      },
      {
        model: 'gt',
        label: 'Greater than',
        disabled: false,
        selected: false,
      },
      {
        model: 'gte',
        label: 'Greater than or equals to',
        disabled: false,
        selected: false,
      },
      {
        model: 'lt',
        label: 'Less than',
        disabled: false,
        selected: false,
      },
      {
        model: 'lte',
        label: 'Less than or equals to',
        disabled: false,
        selected: false,
      },
      {
        model: 'range',
        label: 'Between',
        disabled: false,
        selected: false,
      },
    ],
  },
  {
    model: 'session_source',
    label: 'Session Source',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    type: 'DROPDOWN',
    options: [
      { model: SessionSource.Web, label: 'Web', selected: false, disabled: false },
      { model: SessionSource.Email, label: 'Email', selected: false, disabled: false },
      { model: SessionSource.Phone, label: 'Phone', selected: false, disabled: false },
      {
        model: SessionSource.SMS,
        label: 'SMS',
        selected: false,
        disabled: false,
      },
      {
        model: SessionSource.API,
        label: 'API',
        selected: false,
        disabled: false,
      },
    ],
    pagination: true,
  },
];

export const GatewayTransactionFields: MultiOptions = [
  {
    model: 'dimensions',
    label: 'Dimensions',
    selected: false,
    disabled: false,
    activeCount: 1,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: 'account_id', label: 'Account ID', selected: false, disabled: false },
      { model: 'brand_id', label: 'Brand ID', selected: false, disabled: false },
      { model: 'brand_name', label: 'Brand Name', selected: false, disabled: false },
      {
        model: 'merchant_organization_id',
        label: 'Merchant Org ID',
        selected: false,
        disabled: false,
        isAdminOnly: true,
      },
      { model: 'client_ref_id', label: 'Client Ref ID', selected: false, disabled: false },
      { model: 'transaction_id', label: 'Txn ID', selected: false, disabled: false },
      { model: 'merchant_id', label: 'Merchant ID', selected: false, disabled: false },
      { model: 'parent_transaction_id', label: 'Parent Txn ID', selected: false, disabled: false },
      { model: 'merchant_category_code', label: 'Merchant Category Code', selected: false, disabled: false },
      { model: 'transaction_status', label: 'Txn Status', selected: false, disabled: false },
      { model: 'transaction_amount', label: 'Txn Amount', selected: false, disabled: false },

      { model: 'transaction_success_date', label: 'Txn Success Date', selected: false, disabled: false },
      { model: 'transaction_attempted_date', label: 'Txn Attempted Date', selected: false, disabled: false },

      { model: 'gateway_id', label: 'Gateway ID', selected: false, disabled: false },
      { model: 'gateway_name', label: 'Gateway Name', selected: false, disabled: false },
      { model: 'gateway_type', label: 'Gateway Type', selected: false, disabled: false },
      { model: 'processor_type', label: 'Processor Type', selected: false, disabled: false },
      { model: 'terminal_number', label: 'Terminal Number', selected: false, disabled: false },

      { model: 'transaction_type', label: 'Txn Type', selected: false, disabled: false },

      {
        model: 'transacting_mid_organization_id',
        label: 'Transacting MID Org ID',
        selected: false,
        disabled: false,
        isAdminOnly: true,
      },

      { model: 'acquirer_bin', label: 'Acquirer BIN', selected: false, disabled: false },
      { model: 'acquirer_bank_name', label: 'Acquirer Bank Name', selected: false, disabled: false },
      { model: 'acquirer_country', label: 'Acquirer Country', selected: false, disabled: false },

      { model: 'card_bin', label: 'Card BIN', selected: false, disabled: false },
      { model: 'card_type', label: 'Card Type', selected: false, disabled: false },
      { model: 'issuer_bank_name', label: 'Issuer Bank Name', selected: false, disabled: false },
      { model: 'issuer_country', label: 'Issuer Country', selected: false, disabled: false },

      { model: 'avs_code', label: 'AVS Code', selected: false, disabled: false },
      { model: 'avs_code_value', label: 'AVS Code Value', selected: false, disabled: false },
      { model: 'avs_code_raw', label: 'AVS Code Raw', selected: false, disabled: false },

      {
        model: 'instrument_identifier_id',
        label: 'Instrument Identifier ID',
        selected: false,
        disabled: false,
        isAdminOnly: true,
      },
      {
        model: 'payment_instrument_id',
        label: 'Payment Instrument ID',
        selected: false,
        disabled: false,
        isAdminOnly: true,
      },
      { model: 'eci_raw_value', label: 'ECI Raw Value', selected: false, disabled: false, isAdminOnly: true },

      { model: 'reason', label: 'Reason', selected: false, disabled: false },
      { model: 'message', label: 'Message', selected: false, disabled: false },
      { model: 'reason_code', label: 'Reason Code', selected: false, disabled: false },
      { model: 'action', label: 'Action', selected: false, disabled: false },

      { model: 'response_code', label: 'Response Code', selected: false, disabled: false },
      { model: 'response_code_value', label: 'Response Code Value', selected: false, disabled: false },

      { model: 'decline_source', label: 'Decline Source', selected: false, disabled: false },
      { model: 'pares_status', label: 'PARes Status', selected: false, disabled: false, isAdminOnly: true },
      { model: 'vc_correlation_id', label: 'VC Correlation ID', selected: false, disabled: false, isAdminOnly: true },
      { model: 'three_ds_status', label: '3DS Status', selected: false, disabled: false },
      { model: 'three_ds_enabled', label: '3DS Enabled', selected: false, disabled: false },
      { model: 'veres_enrolled', label: 'VERes Enrolled', selected: false, disabled: false, isAdminOnly: true },

      { model: 'ecommerce_indicator', label: 'E-commerce Indicator', selected: false, disabled: false },
      { model: 'directory_server_error_code', label: 'Directory Server Error Code', selected: false, disabled: false },
      {
        model: 'directory_server_error_description',
        label: 'Directory Server Error Description',
        selected: false,
        disabled: false,
      },

      { model: 'reconciliation_id', label: 'Reconciliation ID', selected: false, disabled: false },
      { model: 'order_id', label: 'Order ID', selected: false, disabled: false },

      { model: 'customer_email', label: 'Cust Email', selected: false, disabled: false },
      { model: 'customer_first_name', label: 'Cust First Name', selected: false, disabled: false },
      { model: 'customer_last_name', label: 'Cust Last Name', selected: false, disabled: false },
      { model: 'card_last_four', label: 'Card Last Four', selected: false, disabled: false },

      { model: 'billing_name', label: 'Billing Name', selected: false, disabled: false },
      { model: 'billing_email', label: 'Billing Email', selected: false, disabled: false },
      { model: 'billing_address', label: 'Billing Address', selected: false, disabled: false },
      { model: 'billing_phone', label: 'Billing Phone', selected: false, disabled: false },

      { model: 'shipping_email', label: 'Shipping Email', selected: false, disabled: false },
      { model: 'shipping_address', label: 'Shipping Address', selected: false, disabled: false },

      { model: 'network_transaction_id', label: 'Network Txn ID', selected: false, disabled: false },
      { model: 'approval_code', label: 'Approval Code', selected: false, disabled: false },

      { model: 'tax_amount', label: 'Tax Amount', selected: false, disabled: false },
      { model: 'authorized_amount', label: 'Authorized Amount', selected: false, disabled: false },

      { model: 'ach_verification_code', label: 'ACH Verification Code', selected: false, disabled: false },
      { model: 'ach_verification_code_value', label: 'ACH Verification Code Value', selected: false, disabled: false },
      { model: 'ach_verification_code_raw', label: 'ACH Verification Code Raw', selected: false, disabled: false },
      {
        model: 'ach_verification_code_raw_value',
        label: 'ACH Verification Code Raw Value',
        selected: false,
        disabled: false,
      },

      { model: 'ip_address', label: 'IP Address', selected: false, disabled: false },
      { model: 'host_name', label: 'Host Name', selected: false, disabled: false },

      { model: 'cvv_result_code', label: 'CVV Result Code', selected: false, disabled: false },
      { model: 'cvv_result_code_value', label: 'CVV Result Code Value', selected: false, disabled: false },
      { model: 'cvv_result_code_raw', label: 'CVV Result Code Raw', selected: false, disabled: false },

      { model: 'cdn_installed', label: 'CDN Installed', selected: false, disabled: false },
      { model: 'is_rebill_transaction', label: 'Is Rebill Txn', selected: false, disabled: false },
      { model: 'customer_vault_id', label: 'Cust Vault ID', selected: false, disabled: false, isAdminOnly: true },

      { model: 'source_url', label: 'Source URL', selected: false, disabled: false, isAdminOnly: true },
    ],
  },
];

export const GatewayTransactionFilters: MultiOptions = [
  {
    model: 'gateway_id',
    label: 'Gateway ID',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    inputType: 'number',
    placeholder: 'Enter Gateway ID',
    type: 'INPUT',
  },
  {
    model: 'gateway_name',
    label: 'Gateway Name',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    placeholder: 'Enter Gateway Name',
    type: 'INPUT',
  },
  {
    model: 'processor_type',
    label: 'Processor',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: ProcessorType.FDIGlobal, label: ProcessorTypeLabels[ProcessorType.FDIGlobal], selected: false, disabled: false },
      { model: ProcessorType.ChasePaymentTech, label: ProcessorTypeLabels[ProcessorType.ChasePaymentTech], selected: false, disabled: false },
      { model: ProcessorType.Elavon, label: ProcessorTypeLabels[ProcessorType.Elavon], selected: false, disabled: false },
      { model: ProcessorType.Tsys, label: ProcessorTypeLabels[ProcessorType.Tsys], selected: false, disabled: false },
      { model: ProcessorType.SmartFDC, label: ProcessorTypeLabels[ProcessorType.SmartFDC], selected: false, disabled: false },
      { model: ProcessorType.Streamline2, label: ProcessorTypeLabels[ProcessorType.Streamline2], selected: false, disabled: false },
      { model: ProcessorType.VPCQorpay, label: ProcessorTypeLabels[ProcessorType.VPCQorpay], selected: false, disabled: false },
    ],
  },
  {
    model: 'merchant_id',
    label: 'Merchant ID',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    options: [],
    placeholder: 'Enter Merchant ID',
    type: 'INPUT',
  },
  {
    model: 'merchant_category_code',
    label: 'Merchant Category Code',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    placeholder: 'Enter MCC',
    type: 'INPUT',
  },
  {
    model: 'transaction_type',
    label: 'Transaction Type',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    type: 'DROPDOWN',
    options: [
      { model: GatewayTransactionType.Sale, label: GatewayTransactionTypeLabels[GatewayTransactionType.Sale], selected: false, disabled: false },
      { model: GatewayTransactionType.Authorize, label: GatewayTransactionTypeLabels[GatewayTransactionType.Authorize], selected: false, disabled: false },
      { model: GatewayTransactionType.Capture, label: GatewayTransactionTypeLabels[GatewayTransactionType.Capture], selected: false, disabled: false },
      { model: GatewayTransactionType.Void, label: GatewayTransactionTypeLabels[GatewayTransactionType.Void], selected: false, disabled: false },
      { model: GatewayTransactionType.Refund, label: GatewayTransactionTypeLabels[GatewayTransactionType.Refund], selected: false, disabled: false },
    ],
  },
  {
    model: 'three_ds_status',
    label: '3DS Status',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    placeholder: 'Enter 3DS Status',
    type: 'INPUT',
  },
  {
    model: 'transaction_status',
    label: 'Transaction Status',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: GatewayTransactionStatus.Authorized, label: GatewayTransactionStatusLabels[GatewayTransactionStatus.Authorized], selected: false, disabled: false },
      { model: GatewayTransactionStatus.PartialAuthorized, label: GatewayTransactionStatusLabels[GatewayTransactionStatus.PartialAuthorized], selected: false, disabled: false },
      { model: GatewayTransactionStatus.AuthorizedPendingReview, label: GatewayTransactionStatusLabels[GatewayTransactionStatus.AuthorizedPendingReview], selected: false, disabled: false },
      { model: GatewayTransactionStatus.Pending, label: GatewayTransactionStatusLabels[GatewayTransactionStatus.Pending], selected: false, disabled: false },
      { model: GatewayTransactionStatus.Voided, label: GatewayTransactionStatusLabels[GatewayTransactionStatus.Voided], selected: false, disabled: false },
      { model: GatewayTransactionStatus.AuthorizedRiskDeclined, label: GatewayTransactionStatusLabels[GatewayTransactionStatus.AuthorizedRiskDeclined], selected: false, disabled: false },
      { model: GatewayTransactionStatus.PendingAuthentication, label: GatewayTransactionStatusLabels[GatewayTransactionStatus.PendingAuthentication], selected: false, disabled: false },
      { model: GatewayTransactionStatus.PendingReview, label: GatewayTransactionStatusLabels[GatewayTransactionStatus.PendingReview], selected: false, disabled: false },
      { model: GatewayTransactionStatus.Declined, label: GatewayTransactionStatusLabels[GatewayTransactionStatus.Declined], selected: false, disabled: false },
      { model: GatewayTransactionStatus.InvalidRequest, label: GatewayTransactionStatusLabels[GatewayTransactionStatus.InvalidRequest], selected: false, disabled: false },
    ],
  },
  {
    model: 'acquirer_bank_name',
    label: 'Acquirer Bank Name',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    placeholder: 'Enter Acquirer Bank Name',
    type: 'INPUT',
  },
  {
    model: 'three_ds_enabled',
    label: '3DS Enabled',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    placeholder: 'Enter 3DS Enabled',
    type: 'INPUT',
  },
  {
    model: 'card_bin',
    label: 'Card BIN',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    placeholder: 'Enter Card BIN',
    type: 'INPUT',
  },
  {
    model: 'issuer_bank_name',
    label: 'Issuer Bank Name',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    placeholder: 'Enter Issuer Bank Name',
    type: 'INPUT',
  },
  {
    model: 'card_type',
    label: 'Card Type',
    selected: false,
    disabled: false,
    loading: false,
    activeCount: 0,
    type: 'DROPDOWN',
    options: [
      { model: GatewayCardType.None, label: GatewayCardTypeLabels[GatewayCardType.None], selected: false, disabled: false },
      { model: GatewayCardType.Visa, label: GatewayCardTypeLabels[GatewayCardType.Visa], selected: false, disabled: false },
      { model: GatewayCardType.Mastercard, label: GatewayCardTypeLabels[GatewayCardType.Mastercard], selected: false, disabled: false },
      { model: GatewayCardType.Amex, label: GatewayCardTypeLabels[GatewayCardType.Amex], selected: false, disabled: false },
      { model: GatewayCardType.Discover, label: GatewayCardTypeLabels[GatewayCardType.Discover], selected: false, disabled: false },
      { model: GatewayCardType.Other, label: GatewayCardTypeLabels[GatewayCardType.Other], selected: false, disabled: false },
    ],
  },
];

export const amountKeys = [
  'SAVE AMOUNT',
  'REFUND AMOUNT',
  'AMOUNT PAID',
  'PARTIAL REFUND AMOUNT',
  'FULL REFUND AMOUNT',
  'AMOUNT',
  'TAX AMOUNT',
  'AUTHORIZED AMOUNT',
];
export const percentageKeys = [
  'CANCEL SUBSCRIPTION RETENTION RATE',
  'RETURN RETENTION RATE',
  'CANCEL ORDER RETENTION RATE',
  'CHARGEBACK RATIO',
  'ALERT RATIO',
  'DISPUTE RATIO',
];

export const rateKeys = ['SAVE SUBSCRIPTION RATE', 'RMA SAVE RATE', 'SAVE HOLD RATE'];

export const ignoredSummaryFields = [
  'extra_for_grouping',
  'exclude_tests',
  'exclude_zeroes',
  'exclude_hangups',
  'exclude_unknowns',
  'exclude_child_sessions',
  'exclude_child_orders',
];

export const SubscriptionRetentionReportsExtraFields: MultiOptions = [
  {
    model: 'last_subscription_step',
    label: 'Step Name',
    selected: false,
    disabled: false,
    activeCount: 0,
    type: 'DROPDOWN',
  },
];

export const SubscriptionRetentionReportsExtraFilters: MultiOptions = [
  {
    model: 'last_subscription_step',
    label: 'Step Name',
    selected: false,
    disabled: false,
    loading: true,
    activeCount: 0,
    options: [],
    searchTerm: '',
    type: 'DROPDOWN',
  },
];

export const NewOrderRetentionReportsExtraFields: MultiOptions = [
  {
    model: 'last_hold_step',
    label: 'Step Name',
    selected: false,
    disabled: false,
    activeCount: 0,
    type: 'DROPDOWN',
  },
];

export const NewOrderRetentionReportsExtraFilters: MultiOptions = [
  {
    model: 'last_hold_step',
    label: 'Step Name',
    selected: false,
    disabled: false,
    loading: true,
    activeCount: 0,
    options: [],
    searchTerm: '',
    type: 'DROPDOWN',
  },
];

export const RmaRetentionReportsExtraFields: MultiOptions = [
  {
    model: 'last_rma_step',
    label: 'Step Name',
    selected: false,
    disabled: false,
    activeCount: 0,
    type: 'DROPDOWN',
  },
];

export const RmaRetentionReportsExtraFilters: MultiOptions = [
  {
    model: 'last_rma_step',
    label: 'Step Name',
    selected: false,
    disabled: false,
    loading: true,
    activeCount: 0,
    options: [],
    searchTerm: '',
    type: 'DROPDOWN',
  },
];

export const OrderOptionsFields: MultiOptions = [
  {
    model: 'dimensions',
    label: 'Dimensions',
    selected: false,
    disabled: false,
    activeCount: 1,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      {
        model: 'path_name',
        label: 'Customer Stage',
        selected: true,
        disabled: false,
      },
      {
        model: 'step_name',
        label: 'Step Name',
        selected: true,
        disabled: false,
      },
      {
        model: 'impressions',
        label: 'Impressions',
        selected: true,
        disabled: false,
      },
      {
        model: 'hold_saves',
        label: 'Hold Saves',
        selected: true,
        disabled: false,
      },
      {
        model: 'subscription_saves',
        label: 'Subscription Saves',
        selected: true,
        disabled: false,
      },
      {
        model: 'rma_saves',
        label: 'RMA Saves',
        selected: true,
        disabled: false,
      },
    ],
  },
];

export const OrderOptionsFilters: MultiOptions = [
  {
    model: 'campaign_id',
    label: 'Brand',
    selected: false,
    disabled: false,
    loading: true,
    activeCount: 0,
    options: [],
    searchTerm: '',
    type: 'DROPDOWN',
  },
];

export const SingleStepFields: MultiOptions = [
  {
    model: 'dimensions',
    label: 'Dimensions',
    selected: false,
    disabled: false,
    activeCount: 1,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      {
        model: ReportDimensions.PathName,
        label: 'Single Step',
        selected: true,
        disabled: false,
      },
      {
        model: ReportDimensions.StepImpressions,
        label: 'Step',
        selected: true,
        disabled: false,
      },
      {
        model: ReportDimensions.Impressions,
        label: 'Impressions',
        selected: true,
        disabled: false,
      },
      {
        model: ReportDimensions.HoldSaves,
        label: 'Hold Saves',
        selected: true,
        disabled: false,
      },
      {
        model: ReportDimensions.SubscriptionSaves,
        label: 'Subscription Saves',
        selected: true,
        disabled: false,
      },
      {
        model: ReportDimensions.RmaSaves,
        label: 'RMA Saves',
        selected: true,
        disabled: false,
      },
    ],
  },
];

export const SingleStepFilters: MultiOptions = [
  {
    model: ReportDimensions.CampaignID,
    label: 'Brand',
    selected: false,
    disabled: false,
    loading: true,
    activeCount: 0,
    options: [],
    searchTerm: '',
    type: 'DROPDOWN',
  },
];

export const TrafficSourceFields: MultiOptions = [
  {
    model: 'dimensions',
    label: 'Dimensions',
    selected: false,
    disabled: false,
    activeCount: 1,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      {
        model: 'source',
        label: 'Path channel',
        selected: true,
        disabled: false,
      },
      {
        model: 'sid1',
        label: 'Source sub 1',
        selected: true,
        disabled: false,
      },
      {
        model: 'sid2',
        label: 'Source sub 2',
        selected: true,
        disabled: false,
      },
      {
        model: 'tracking_source',
        label: 'Path channel source',
        selected: true,
        disabled: false,
      },
      {
        model: 'session_count',
        label: 'Session Quantity',
        selected: true,
        disabled: false,
      },
    ],
  },
];

export const TrafficSourceFilters: MultiOptions = [
  {
    model: 'campaign_id',
    label: 'Brand',
    selected: false,
    disabled: false,
    loading: true,
    activeCount: 0,
    options: [],
    searchTerm: '',
    type: 'DROPDOWN',
  },
];

export const subscriptionRetentionFields: MultiOptions = [
  {
    model: 'general',
    label: 'General',
    selected: false,
    disabled: false,
    activeCount: 1,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: 'product_name_id', label: 'Campaign Product', selected: false, disabled: false },
      { model: 'base_product_name_id', label: 'Base Product', selected: false, disabled: false },
      { model: 'product_variant', label: 'Product Variant', selected: false, disabled: false },
      { model: 'campaign_name', label: 'Brand', selected: false, disabled: false },
      { model: 'crm_campaign_name_id', label: 'Campaign', selected: false, disabled: false },
      { model: 'cancel_reason', label: 'Cancel Reason', selected: true, disabled: false },
      { model: 'cancel_reason_category_name', label: 'Cancel Reason Category', selected: false, disabled: false },
      { model: 'billing_cycle', label: 'Billing Cycle', selected: false, disabled: false },
      { model: 'billing_interval_days', label: 'Billing Frequency', selected: false, disabled: false },
      { model: 'crm_name', label: 'Platform', selected: false, disabled: false },
      { model: 'subscription_audience_name', label: 'Segment', selected: false, disabled: false },
      { model: 'offer_name', label: 'Offer Name', selected: false, disabled: false },
      { model: 'offer_type', label: 'Offer Type', selected: false, disabled: false },
      { model: 'offer_position', label: 'Position', selected: false, disabled: false },
      { model: 'total_accepted', label: 'Accepted', selected: false, disabled: false },
      { model: 'total_impressions', label: 'Impressions', selected: false, disabled: false },
      { model: 'total_rejections', label: 'Rejected Offers', selected: false, disabled: false },
      { model: 'canceled_with_order', label: 'Canceled With Order', selected: false, disabled: false },
      { model: 'journey_id', label: 'Journey ID', selected: false, disabled: false },
      { model: 'initial_intent', label: 'Initial Intent', selected: false, disabled: false },
      { model: 'final_intent', label: 'Final Intent', selected: false, disabled: false },
      { model: 'customer_email', label: 'Customer Email', selected: false, disabled: false },
    ],
  },
  {
    model: 'traffic',
    label: 'Traffic',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: 'tracking_source', label: 'Traffic Source', selected: false, disabled: false },
      { model: 'aff_id', label: 'Affiliate ID', selected: false, disabled: false },
      { model: 'sub_id_1', label: 'Sub ID', selected: false, disabled: false },
      { model: 'sub_id_2', label: 'Sub ID 2', selected: false, disabled: false },
      { model: 'sub_id_3', label: 'Sub ID 3', selected: false, disabled: false },
    ],
  },
  {
    model: 'device',
    label: 'Device',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: 'device_type', label: 'Device Type', selected: false, disabled: false },
      { model: 'os_name', label: 'Operating System', selected: false, disabled: false },
      { model: 'browser_name', label: 'Browser', selected: false, disabled: false },
      { model: 'device_brand', label: 'Device Brand', selected: false, disabled: false },
    ],
  },
  {
    model: 'detailed_view',
    label: 'Detailed View',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: 'customer_id', label: 'Customer ID', selected: false, disabled: false },
      { model: 'order_id', label: 'Order ID', selected: false, disabled: false },
      { model: 'session_id', label: 'Session ID', selected: false, disabled: false },
    ],
  },
  {
    model: 'miscellaneous',
    label: 'Miscellaneous',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: 'input_name', label: 'Input Name', selected: false, disabled: false },
      { model: 'subscription_path', label: 'Product Path', selected: false, disabled: false },
    ],
  },
];

export const subscriptionRetentionFilters: MultiOptions = [
  {
    model: 'general',
    label: 'General',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      {
        model: 'product_id',
        label: 'Campaign Product',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        pagination: true,
        type: 'DROPDOWN',
      },
      {
        model: 'base_product_id',
        label: 'Base Product',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'product_variant',
        label: 'Product Variant',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'crm_campaign_id',
        label: 'Campaign',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'cancel_reason',
        label: 'Cancel Reason',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'cancel_reason_category_name',
        label: 'Cancel Reason Category',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'billing_cycle',
        label: 'Billing Cycle',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'billing_interval_days',
        label: 'Billing Frequency',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'offer_type',
        label: 'Offer Type',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'crm_name',
        label: 'Platform',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'subscription_audience_id',
        label: 'Segment',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'canceled_with_order',
        label: 'Canceled With Order',
        selected: false,
        disabled: false,
        activeCount: 0,
        options: [
          { model: BooleanFilterValue.Yes, label: 'Yes', selected: false, disabled: false },
          { model: BooleanFilterValue.No, label: 'No', selected: false, disabled: false },
        ],
        searchTerm: '',
        type: FilterType.Dropdown,
        singleValue: true,
      },
      {
        model: 'journey_id',
        label: 'Journey ID',
        selected: false,
        disabled: false,
        activeCount: 0,
        searchTerm: '',
        type: FilterType.Input,
        inputType: 'number',
        placeholder: 'Enter Journey ID',
      },
      {
        model: 'initial_intent',
        label: 'Initial Intent',
        selected: false,
        disabled: false,
        activeCount: 0,
        options: Object.keys(JourneyIntentLabels).map((key) => ({
          model: Number(key),
          label: JourneyIntentLabels[Number(key)],
          selected: false,
          disabled: false,
        })),
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'final_intent',
        label: 'Final Intent',
        selected: false,
        disabled: false,
        activeCount: 0,
        options: Object.keys(JourneyIntentLabels).map((key) => ({
          model: Number(key),
          label: JourneyIntentLabels[Number(key)],
          selected: false,
          disabled: false,
        })),
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'customer_email',
        label: 'Customer Email',
        selected: false,
        disabled: false,
        activeCount: 0,
        searchTerm: '',
        type: FilterType.Input,
        inputType: 'text',
        placeholder: 'Enter Customer Email',
      },
    ] as MultiOptions,
  },
  {
    model: 'traffic',
    label: 'Traffic',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      {
        model: 'tracking_source',
        label: 'Traffic Source',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'aff_id',
        label: 'Affiliate ID',
        selected: false,
        disabled: false,
        activeCount: 0,
        searchTerm: '',
        type: 'INPUT',
        inputType: 'text',
        placeholder: 'Enter Affiliate ID',
      },
      {
        model: 'sub_id_1',
        label: 'Sub ID',
        selected: false,
        disabled: false,
        activeCount: 0,
        searchTerm: '',
        type: 'INPUT',
        inputType: 'text',
        placeholder: 'Enter Sub ID',
      },
      {
        model: 'sub_id_2',
        label: 'Sub ID 2',
        selected: false,
        disabled: false,
        activeCount: 0,
        searchTerm: '',
        type: 'INPUT',
        inputType: 'text',
        placeholder: 'Enter Sub ID 2',
      },
      {
        model: 'sub_id_3',
        label: 'Sub ID 3',
        selected: false,
        disabled: false,
        activeCount: 0,
        searchTerm: '',
        type: 'INPUT',
        inputType: 'text',
        placeholder: 'Enter Sub ID 3',
      },
    ] as MultiOptions,
  },
  {
    model: 'device',
    label: 'Device',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      {
        model: 'device_type',
        label: 'Device Type',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'os_name',
        label: 'Operating System',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'browser_name',
        label: 'Browser',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'device_brand',
        label: 'Device Brand',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
    ] as MultiOptions,
  },
  {
    model: 'miscellaneous',
    label: 'Miscellaneous',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      {
        model: 'customer_stage',
        label: 'Product Path',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
    ] as MultiOptions,
  },
];

export const newOrderRetentionFields: MultiOptions = [
  {
    model: 'general',
    label: 'General',
    selected: false,
    disabled: false,
    activeCount: 1,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: 'product_name_id', label: 'Campaign Product', selected: false, disabled: false },
      { model: 'base_product_name_id', label: 'Base Product', selected: false, disabled: false },
      { model: 'product_variant', label: 'Product Variant', selected: false, disabled: false },
      { model: 'campaign_name', label: 'Brand', selected: false, disabled: false },
      { model: 'crm_campaign_name_id', label: 'Campaign', selected: false, disabled: false },
      { model: 'cancel_reason', label: 'Cancel Reason', selected: true, disabled: false },
      { model: 'cancel_reason_category_name', label: 'Cancel Reason Category', selected: false, disabled: false },
      { model: 'product_role', label: 'Product Role', selected: false, disabled: false },
      { model: 'offer_intent', label: 'Stage', selected: false, disabled: false },
      { model: 'crm_name', label: 'Platform', selected: false, disabled: false },
      { model: 'hold_audience_name', label: 'Segment', selected: false, disabled: false },
      { model: 'offer_name', label: 'Offer Name', selected: false, disabled: false },
      { model: 'offer_type', label: 'Offer Type', selected: false, disabled: false },
      { model: 'offer_position', label: 'Position', selected: false, disabled: false },
      { model: 'total_accepted', label: 'Accepted', selected: false, disabled: false },
      { model: 'total_impressions', label: 'Impressions', selected: false, disabled: false },
      { model: 'sub_attached', label: 'Sub Attached', selected: false, disabled: false },
      { model: 'sub_canceled', label: 'Sub Canceled', selected: false, disabled: false },
      { model: 'journey_id', label: 'Journey ID', selected: false, disabled: false },
      { model: 'initial_intent', label: 'Initial Intent', selected: false, disabled: false },
      { model: 'final_intent', label: 'Final Intent', selected: false, disabled: false },
      { model: 'customer_email', label: 'Customer Email', selected: false, disabled: false },
    ],
  },
  {
    model: 'traffic',
    label: 'Traffic',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: 'tracking_source', label: 'Traffic Source', selected: false, disabled: false },
      { model: 'aff_id', label: 'Affiliate ID', selected: false, disabled: false },
      { model: 'sub_id_1', label: 'Sub ID', selected: false, disabled: false },
      { model: 'sub_id_2', label: 'Sub ID 2', selected: false, disabled: false },
      { model: 'sub_id_3', label: 'Sub ID 3', selected: false, disabled: false },
    ],
  },
  {
    model: 'device',
    label: 'Device',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: 'device_type', label: 'Device Type', selected: false, disabled: false },
      { model: 'os_name', label: 'Operating System', selected: false, disabled: false },
      { model: 'browser_name', label: 'Browser', selected: false, disabled: false },
      { model: 'device_brand', label: 'Device Brand', selected: false, disabled: false },
    ],
  },
  {
    model: 'detailed_view',
    label: 'Detailed View',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: 'customer_id', label: 'Customer ID', selected: false, disabled: false },
      { model: 'order_id', label: 'Order ID', selected: false, disabled: false },
      { model: 'session_id', label: 'Session ID', selected: false, disabled: false },
    ],
  },
  {
    model: 'statistics',
    label: 'Statistics',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: 'item_full_refund_amount', label: 'Full Refund Amount', selected: false, disabled: false },
      { model: 'refund_quantity', label: 'Refund Quantity', selected: false, disabled: false },
      { model: 'item_partial_refund_amount', label: 'Partial Refund Amount', selected: false, disabled: false },
    ],
  },
  {
    model: 'miscellaneous',
    label: 'Miscellaneous',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: 'input_name', label: 'Input Name', selected: false, disabled: false },
      {
        model: 'hold_path',
        label: 'Product Path',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
    ] as MultiOptions,
  },
];

export const newOrderRetentionFilters: MultiOptions = [
  {
    model: 'general',
    label: 'General',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      {
        model: 'product_id',
        label: 'Campaign Product',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        pagination: true,
        type: 'DROPDOWN',
      },
      {
        model: 'base_product_id',
        label: 'Base Product',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'product_variant',
        label: 'Product Variant',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'crm_campaign_id',
        label: 'Campaign',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'cancel_reason',
        label: 'Cancel Reason',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'cancel_reason_category_name',
        label: 'Cancel Reason Category',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'product_role',
        label: 'Product Role',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'offer_type',
        label: 'Offer Type',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'crm_name',
        label: 'Platform',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'hold_audience_id',
        label: 'Segment',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'sub_attached',
        label: 'Sub Attached',
        selected: false,
        disabled: false,
        activeCount: 0,
        options: [
          { model: BooleanFilterValue.Yes, label: 'Yes', selected: false, disabled: false },
          { model: BooleanFilterValue.No, label: 'No', selected: false, disabled: false },
        ],
        searchTerm: '',
        type: FilterType.Dropdown,
        singleValue: true,
      },
      {
        model: 'sub_canceled',
        label: 'Sub Canceled',
        selected: false,
        disabled: false,
        activeCount: 0,
        options: [
          { model: BooleanFilterValue.Yes, label: 'Yes', selected: false, disabled: false },
          { model: BooleanFilterValue.No, label: 'No', selected: false, disabled: false },
        ],
        searchTerm: '',
        type: FilterType.Dropdown,
        singleValue: true,
      },
      {
        model: 'journey_id',
        label: 'Journey ID',
        selected: false,
        disabled: false,
        activeCount: 0,
        searchTerm: '',
        type: FilterType.Input,
        inputType: 'number',
        placeholder: 'Enter Journey ID',
      },
      {
        model: 'initial_intent',
        label: 'Initial Intent',
        selected: false,
        disabled: false,
        activeCount: 0,
        options: Object.keys(JourneyIntentLabels).map((key) => ({
          model: Number(key),
          label: JourneyIntentLabels[Number(key)],
          selected: false,
          disabled: false,
        })),
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'final_intent',
        label: 'Final Intent',
        selected: false,
        disabled: false,
        activeCount: 0,
        options: Object.keys(JourneyIntentLabels).map((key) => ({
          model: Number(key),
          label: JourneyIntentLabels[Number(key)],
          selected: false,
          disabled: false,
        })),
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'customer_email',
        label: 'Customer Email',
        selected: false,
        disabled: false,
        activeCount: 0,
        searchTerm: '',
        type: FilterType.Input,
        inputType: 'text',
        placeholder: 'Enter Customer Email',
      },
    ] as MultiOptions,
  },
  {
    model: 'traffic',
    label: 'Traffic',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      {
        model: 'tracking_source',
        label: 'Traffic Source',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'aff_id',
        label: 'Affiliate ID',
        selected: false,
        disabled: false,
        activeCount: 0,
        searchTerm: '',
        type: 'INPUT',
        inputType: 'text',
        placeholder: 'Enter Affiliate ID',
      },
      {
        model: 'sub_id_1',
        label: 'Sub ID',
        selected: false,
        disabled: false,
        activeCount: 0,
        searchTerm: '',
        type: 'INPUT',
        inputType: 'text',
        placeholder: 'Enter Sub ID',
      },
      {
        model: 'sub_id_2',
        label: 'Sub ID 2',
        selected: false,
        disabled: false,
        activeCount: 0,
        searchTerm: '',
        type: 'INPUT',
        inputType: 'text',
        placeholder: 'Enter Sub ID 2',
      },
      {
        model: 'sub_id_3',
        label: 'Sub ID 3',
        selected: false,
        disabled: false,
        activeCount: 0,
        searchTerm: '',
        type: 'INPUT',
        inputType: 'text',
        placeholder: 'Enter Sub ID 3',
      },
    ] as MultiOptions,
  },
  {
    model: 'device',
    label: 'Device',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      {
        model: 'device_type',
        label: 'Device Type',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'os_name',
        label: 'Operating System',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'browser_name',
        label: 'Browser',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
      {
        model: 'device_brand',
        label: 'Device Brand',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
    ] as MultiOptions,
  },
  {
    model: 'miscellaneous',
    label: 'Miscellaneous',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      {
        model: 'customer_stage',
        label: 'Product Path',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: 'DROPDOWN',
      },
    ] as MultiOptions,
  },
];

// ─── Gateway Performance ───────────────────────────────────────────────────
// NOTE: All field/filter model names below are placeholders — confirm exact keys with BE before going live.
export const GatewayPerformanceFields: MultiOptions = [
  {
    model: 'time',
    label: 'Time',
    selected: false,
    disabled: false,
    activeCount: 1,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: 'date', label: 'Date', selected: true, disabled: false },
      { model: 'day_of_week', label: 'Day of Week', selected: false, disabled: false },
      { model: 'hour_of_day', label: 'Hour of Day', selected: false, disabled: false },
      { model: 'month', label: 'Month', selected: false, disabled: false },
    ],
  },
  {
    model: 'transaction_lifecycle',
    label: 'Transaction & Lifecycle',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: 'transaction_type', label: 'Transaction Type', selected: false, disabled: false },
      { model: 'sales_type', label: 'Transaction Lifecycle Type', selected: false, disabled: false },
      { model: 'billing_cycle', label: 'Billing Cycle Number', selected: false, disabled: false },
      { model: 'billing_cycle_group', label: 'Billing Cycle Group', selected: false, disabled: false },
      { model: 'attempt_number', label: 'Attempt Number', selected: false, disabled: true, unavailable: true }, // deferred: retry logic not implemented
    ],
  },
  {
    model: 'outcomes_declines',
    label: 'Outcomes & Declines',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: 'decline_source', label: 'Decline Source', selected: false, disabled: false },
      { model: 'decline_code', label: 'Decline Reason Code', selected: false, disabled: false },
      { model: 'decline_category', label: 'Decline Category', selected: false, disabled: true, unavailable: true }, // deferred: not yet implemented
    ],
  },
  {
    model: 'card_issuer',
    label: 'Card & Issuer',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: 'card_type', label: 'Card Brand', selected: false, disabled: false },
      { model: 'card_bin', label: 'BIN', selected: false, disabled: false },
      { model: 'issuer_country', label: 'Issuer Country', selected: false, disabled: false },
      { model: 'issuer_bank_name', label: 'Bank', selected: false, disabled: false },
      { model: 'card_level', label: 'Card Type', selected: false, disabled: false },
    ],
  },
  {
    model: 'product_traffic',
    label: 'Product & Traffic',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: 'traffic_source', label: 'Traffic Source', selected: false, disabled: false },
      { model: 'gateway_name', label: 'Merchant/Acquirer', selected: false, disabled: false },
      { model: 'product_id', label: 'Product ID', selected: false, disabled: false },
      { model: 'product_name', label: 'Product Name', selected: false, disabled: false },
      { model: 'campaign_id', label: 'Campaign ID', selected: false, disabled: false },
      { model: 'affiliate_id', label: 'Affiliate ID', selected: false, disabled: false },
      { model: 'sub_id', label: 'Sub ID 1', selected: false, disabled: false },
      { model: 'sub_id2', label: 'Sub ID 2', selected: false, disabled: false },
      { model: 'sub_id3', label: 'Sub ID 3', selected: false, disabled: false },
    ],
  },
  {
    model: 'auth_tokens',
    label: 'Auth & Tokens',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: 'three_ds_enabled', label: '3DS Applied', selected: false, disabled: false },
      { model: 'three_ds_type', label: '3DS Type', selected: false, disabled: false },
      { model: 'nt_used', label: 'Token Used', selected: false, disabled: false },
      { model: 'level3_enabled', label: 'Level 3 Data', selected: false, disabled: false },
    ],
  },
  {
    model: 'refunds',
    label: 'Refunds',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: 'DROPDOWN',
    options: [
      { model: 'refund_count', label: 'Refund Count', selected: false, disabled: true, unavailable: true }, // deferred: no backing columns yet
      { model: 'refund_amount', label: 'Refund Amount', selected: false, disabled: true, unavailable: true }, // deferred: no backing columns yet
      { model: 'refund_type', label: 'Refund Type', selected: false, disabled: false },
    ],
  },
];

export const GatewayPerformanceFilters: MultiOptions = [
  {
    model: 'general',
    label: 'General',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: FilterType.Dropdown,
    options: [
      {
        model: 'price_point',
        label: 'Price Point',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
    ],
  },
  {
    model: 'transaction_lifecycle',
    label: 'Transaction & Lifecycle',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: FilterType.Dropdown,
    options: [
      {
        model: 'transaction_type',
        label: 'Transaction Type',
        selected: false,
        disabled: false,
        loading: false,
        activeCount: 0,
        options: [
          { model: 'sale', label: 'Sale', selected: false, disabled: false },
          { model: 'authorize', label: 'Authorize', selected: false, disabled: false },
          { model: 'capture', label: 'Capture', selected: false, disabled: false },
          { model: 'refund', label: 'Refund', selected: false, disabled: false },
          { model: 'void', label: 'Void', selected: false, disabled: false },
        ],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'billing_cycle',
        label: 'Billing Cycle Number',
        selected: false,
        disabled: false,
        loading: false,
        activeCount: 0,
        placeholder: 'Enter Billing Cycle Number',
        inputType: FilterInputType.Number,
        type: FilterType.Input,
      },
      {
        model: 'attempt_number',
        label: 'Attempt Number',
        selected: false,
        disabled: true,
        unavailable: true,
        loading: false,
        activeCount: 0,
        placeholder: 'Enter Attempt Number',
        inputType: FilterInputType.Number,
        type: FilterType.Input,
      },
    ],
  },
  {
    model: 'outcomes_declines',
    label: 'Outcomes & Declines',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: FilterType.Dropdown,
    options: [
      {
        model: 'decline_source',
        label: 'Decline Source',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'decline_category',
        label: 'Decline Category',
        selected: false,
        disabled: true,
        unavailable: true,
        loading: false,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
    ],
  },
  {
    model: 'card_issuer',
    label: 'Card & Issuer',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: FilterType.Dropdown,
    options: [
      {
        model: 'card_type',
        label: 'Card Brand',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'card_bin',
        label: 'BIN',
        selected: false,
        disabled: false,
        loading: false,
        activeCount: 0,
        placeholder: 'Enter BIN',
        inputType: FilterInputType.Text,
        type: FilterType.Input,
      },
      {
        model: 'issuer_country',
        label: 'Issuer Country',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'issuer_bank_name',
        label: 'Bank',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'merchant_category_code',
        label: 'Merchant Category Code (MCC)',
        selected: false,
        disabled: false,
        loading: false,
        activeCount: 0,
        placeholder: 'Enter MCC',
        inputType: FilterInputType.Text,
        type: FilterType.Input,
      },
      {
        model: 'card_level',
        label: 'Card Type',
        selected: false,
        disabled: false,
        loading: false,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
    ],
  },
  {
    model: 'product_traffic',
    label: 'Product & Traffic',
    selected: false,
    activeCount: 0,
    searchTerm: '',
    type: FilterType.Dropdown,
    options: [
      {
        model: 'traffic_source',
        label: 'Traffic Source',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'gateway_name',
        label: 'Merchant/Acquirer',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'product_id',
        label: 'Product ID',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'product_name',
        label: 'Product Name',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'campaign_id',
        label: 'Campaign ID',
        selected: false,
        disabled: false,
        loading: false,
        activeCount: 0,
        placeholder: 'Enter Campaign ID',
        inputType: FilterInputType.Text,
        type: FilterType.Input,
      },
      {
        model: 'affiliate_id',
        label: 'Affiliate ID',
        selected: false,
        disabled: false,
        loading: false,
        activeCount: 0,
        placeholder: 'Enter Affiliate ID',
        inputType: FilterInputType.Text,
        type: FilterType.Input,
      },
      {
        model: 'sub_id',
        label: 'Sub ID 1',
        selected: false,
        disabled: false,
        loading: false,
        activeCount: 0,
        placeholder: 'Enter Sub ID 1',
        inputType: FilterInputType.Text,
        type: FilterType.Input,
      },
      {
        model: 'sub_id2',
        label: 'Sub ID 2',
        selected: false,
        disabled: false,
        loading: false,
        activeCount: 0,
        placeholder: 'Enter Sub ID 2',
        inputType: FilterInputType.Text,
        type: FilterType.Input,
      },
      {
        model: 'sub_id3',
        label: 'Sub ID 3',
        selected: false,
        disabled: false,
        loading: false,
        activeCount: 0,
        placeholder: 'Enter Sub ID 3',
        inputType: FilterInputType.Text,
        type: FilterType.Input,
      },
    ],
  },
  {
    model: 'auth_tokens',
    label: 'Auth & Tokens',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: FilterType.Dropdown,
    options: [
      {
        model: 'three_ds_enabled',
        label: '3DS Applied',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [
          { model: BooleanFilterValue.Yes, label: 'Yes', selected: false, disabled: false },
          { model: BooleanFilterValue.No, label: 'No', selected: false, disabled: false },
        ],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'three_ds_type',
        label: '3DS Type',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'nt_used',
        label: 'Token Used',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [
          { model: BooleanFilterValue.Yes, label: 'Yes', selected: false, disabled: false },
          { model: BooleanFilterValue.No, label: 'No', selected: false, disabled: false },
        ],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
    ],
  },
];

// ──────────────────────────────────────────────────────────────────────────────

export const mergedDimensionFields: { [key: string]: string[] } = {
  product_name_id: ['product_name', 'product_id'],
  base_product_name_id: ['base_product_name', 'base_product_id'],
  campaign_name_id: ['campaign_name', 'campaign_id'],
  crm_campaign_name_id: ['crm_campaign_name', 'crm_campaign_id'],
  offer_name: ['offer_name', 'offer_id'],
};

export const dimensionGroupModels = [
  'dimensions', 'general', 'traffic', 'device', 'detailed_view', 'miscellaneous',
  'time', 'transaction_lifecycle', 'outcomes_declines', 'card_issuer', 'product_traffic', 'auth_tokens', 'refunds',
  'journey_session', 'journey_item', 'journey_intent',
];

export const OfferNavKeys = {
  stageId: 'nav_stage_id',
  intent: 'nav_intent',
  offerId: 'nav_offer_id',
  category: 'nav_category',
  funnelType: 'nav_funnel_type',
} as const;

export const defaultOfferGroupFields = ['offer_type', 'offer_id', 'offer_name', 'position', 'impressions', 'total_rejections', 'accepted', 'accepted_pct', 'avg_mrr_saved'];

export const sortableOfferGroupKeys: string[] = ['position', 'impressions', 'total_rejections', 'accepted'];

export const offerGroupHeaders = [
  { key: 'offer_type', label: 'Offer Type', hasHelp: false },
  { key: 'offer_name', label: 'Offer Name', hasHelp: false, isOfferName: true },
  { key: 'position', label: 'Position', hasHelp: false },
  { key: 'impressions', label: 'Impressions', hasHelp: false },
  { key: 'accepted', label: 'Accepted', hasHelp: true },
  { key: 'total_rejections', label: 'Rejected', hasHelp: false },
  { key: 'accepted_pct', label: 'Accepted %', hasHelp: true },
  { key: 'avg_mrr_saved', label: 'Avg MRR Saved', hasHelp: true },
];

export const returnRetentionFields: MultiOptions = [
  {
    model: 'general',
    label: 'General',
    selected: false,
    disabled: false,
    activeCount: 1,
    searchTerm: '',
    type: FilterType.Dropdown,
    options: [
      { model: 'session_count', label: 'Sessions', selected: false, disabled: false },
      { model: 'product_name_id', label: 'Campaign Product', selected: false, disabled: false },
      { model: 'base_product_name_id', label: 'Base Product', selected: false, disabled: false },
      { model: 'product_variant', label: 'Product Variant', selected: false, disabled: false },
      { model: 'crm_campaign_name_id', label: 'Campaign', selected: false, disabled: false },
      { model: 'cancel_reason', label: 'Return Reason', selected: true, disabled: false },
      { model: 'billing_cycle', label: 'Billing Cycle', selected: false, disabled: false },
      { model: 'product_role', label: 'Product Role', selected: false, disabled: false },
      { model: 'rma_audience_name', label: 'Segment', selected: false, disabled: false },
      { model: 'label_created', label: 'Labels Created', selected: false, disabled: false },
      { model: 'offer_name', label: 'Offer Name', selected: false, disabled: false },
      { model: 'offer_type', label: 'Offer Type', selected: false, disabled: false },
      { model: 'offer_position', label: 'Position', selected: false, disabled: false },
      { model: 'total_accepted', label: 'Accepted', selected: false, disabled: false },
      { model: 'total_impressions', label: 'Impressions', selected: false, disabled: false },
      { model: 'total_rejections', label: 'Rejected Offers', selected: false, disabled: false },
      { model: 'customer_email', label: 'Customer Email', selected: false, disabled: false },
      { model: 'journey_id', label: 'Journey ID', selected: false, disabled: false },
    ],
  },
  {
    model: 'traffic',
    label: 'Traffic',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: FilterType.Dropdown,
    options: [
      { model: 'tracking_source', label: 'Traffic Source', selected: false, disabled: false },
      { model: 'aff_id', label: 'Affiliate ID', selected: false, disabled: false },
      { model: 'sub_id_1', label: 'Sub ID', selected: false, disabled: false },
      { model: 'sub_id_2', label: 'Sub ID 2', selected: false, disabled: false },
      { model: 'sub_id_3', label: 'Sub ID 3', selected: false, disabled: false },
    ],
  },
  {
    model: 'device',
    label: 'Device',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: FilterType.Dropdown,
    options: [
      { model: 'device_type', label: 'Device Type', selected: false, disabled: false },
      { model: 'os_name', label: 'Operating System', selected: false, disabled: false },
      { model: 'browser_name', label: 'Browser', selected: false, disabled: false },
      { model: 'device_brand', label: 'Device Brand', selected: false, disabled: false },
    ],
  },
  {
    model: 'miscellaneous',
    label: 'Miscellaneous',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: FilterType.Dropdown,
    options: [
      { model: 'input_name', label: 'Input Name', selected: false, disabled: false },
      { model: 'rma_path', label: 'Product Path', selected: false, disabled: false },
    ],
  },
];

export const returnRetentionFilters: MultiOptions = [
  {
    model: 'general',
    label: 'General',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: FilterType.Dropdown,
    options: [
      {
        model: 'product_id',
        label: 'Campaign Product',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        pagination: true,
        type: FilterType.Dropdown,
      },
      {
        model: 'base_product_id',
        label: 'Base Product',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'product_variant',
        label: 'Product Variant',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'crm_campaign_id',
        label: 'Campaign',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'cancel_reason',
        label: 'Return Reason',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'billing_cycle',
        label: 'Billing Cycle',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'product_role',
        label: 'Product Role',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'rma_audience_id',
        label: 'Segment',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'offer_type',
        label: 'Offer Type',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'journey_id',
        label: 'Journey ID',
        selected: false,
        disabled: false,
        activeCount: 0,
        searchTerm: '',
        type: FilterType.Input,
        inputType: 'number',
        placeholder: 'Enter Journey ID',
      },
    ] as MultiOptions,
  },
  {
    model: 'traffic',
    label: 'Traffic',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: FilterType.Dropdown,
    options: [
      {
        model: 'tracking_source',
        label: 'Traffic Source',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'aff_id',
        label: 'Affiliate ID',
        selected: false,
        disabled: false,
        activeCount: 0,
        searchTerm: '',
        type: FilterType.Input,
        inputType: 'text',
        placeholder: 'Enter Affiliate ID',
      },
      {
        model: 'sub_id_1',
        label: 'Sub ID',
        selected: false,
        disabled: false,
        activeCount: 0,
        searchTerm: '',
        type: FilterType.Input,
        inputType: 'text',
        placeholder: 'Enter Sub ID',
      },
      {
        model: 'sub_id_2',
        label: 'Sub ID 2',
        selected: false,
        disabled: false,
        activeCount: 0,
        searchTerm: '',
        type: FilterType.Input,
        inputType: 'text',
        placeholder: 'Enter Sub ID 2',
      },
      {
        model: 'sub_id_3',
        label: 'Sub ID 3',
        selected: false,
        disabled: false,
        activeCount: 0,
        searchTerm: '',
        type: FilterType.Input,
        inputType: 'text',
        placeholder: 'Enter Sub ID 3',
      },
      {
        model: 'customer_email',
        label: 'Customer Email',
        selected: false,
        disabled: false,
        activeCount: 0,
        searchTerm: '',
        type: FilterType.Input,
        inputType: 'text',
        placeholder: 'Enter Customer Email',
      },
    ] as MultiOptions,
  },
  {
    model: 'device',
    label: 'Device',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: FilterType.Dropdown,
    options: [
      {
        model: 'device_type',
        label: 'Device Type',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'os_name',
        label: 'Operating System',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'browser_name',
        label: 'Browser',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
      {
        model: 'device_brand',
        label: 'Device Brand',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
    ] as MultiOptions,
  },
  {
    model: 'miscellaneous',
    label: 'Miscellaneous',
    selected: false,
    disabled: false,
    activeCount: 0,
    searchTerm: '',
    type: FilterType.Dropdown,
    options: [
      {
        model: 'customer_stage',
        label: 'Product Path',
        selected: false,
        disabled: false,
        loading: true,
        activeCount: 0,
        options: [],
        searchTerm: '',
        type: FilterType.Dropdown,
      },
    ] as MultiOptions,
  },
];

export const subRetentionStageOptions = [
  { value: OfferIntents.CancelSubscriptionHold, label: OfferStages[OfferIntents.CancelSubscriptionHold] },
  { value: OfferIntents.CancelSubscription, label: OfferStages[OfferIntents.CancelSubscription] },
  { value: OfferIntents.CancelRebillHold, label: OfferStages[OfferIntents.CancelRebillHold] },
];

export const orderRetentionStageOptions = [
  { value: OfferIntents.CancelOrder, label: abbrOfferStageLabel[OfferIntents.CancelOrder] },
  { value: OfferIntents.CancelSubscriptionHold, label: abbrOfferStageLabel[OfferIntents.CancelSubscriptionHold] },
  { value: OfferIntents.CancelRebillHold, label: abbrOfferStageLabel[OfferIntents.CancelRebillHold] },
];

export const returnRetentionStageOptions = [
  { value: OfferIntents.ReturnOrder, label: abbrOfferStageLabel[OfferIntents.ReturnOrder] },
  { value: OfferIntents.ReturnSubscription, label: abbrOfferStageLabel[OfferIntents.ReturnSubscription] },
  { value: OfferIntents.ReturnTrial, label: abbrOfferStageLabel[OfferIntents.ReturnTrial] },
];

const csDimension = ([model, label]: [string, string]): MultiSubOption => ({
  model,
  label,
  selected: false,
  disabled: false,
});

const csDimensionGroup = (model: string, label: string, dimensions: [string, string][]): MultiOption => ({
  model,
  label,
  selected: false,
  disabled: false,
  activeCount: 0,
  searchTerm: '',
  type: FilterType.Dropdown,
  options: dimensions.map(csDimension),
});

// Options come from filter_options at runtime, so the menu starts empty and loading.
const csFetchedFilter = (model: string, label: string): MultiOption => ({
  model,
  label,
  selected: false,
  disabled: false,
  loading: true,
  activeCount: 0,
  options: [],
  searchTerm: '',
  type: FilterType.Dropdown,
});

// Fixed enum menus are never served by filter_options - the values are the contract.
const csEnumFilter = (model: string, label: string, labels: { [value: number]: string }, values?: number[]): MultiOption => ({
  model,
  label,
  selected: false,
  disabled: false,
  loading: false,
  activeCount: 0,
  options: (values || Object.keys(labels).map(Number)).map((value) => ({
    model: value,
    label: labels[value],
    selected: false,
    disabled: false,
  })),
  searchTerm: '',
  type: FilterType.Dropdown,
});

const enumStringFilter = (model: string, label: string, labels: { [value: string]: string }): MultiOption => ({
  model,
  label,
  selected: false,
  disabled: false,
  loading: false,
  activeCount: 0,
  options: Object.keys(labels).map((value) => ({
    model: value,
    label: labels[value],
    selected: false,
    disabled: false,
  })),
  searchTerm: '',
  type: FilterType.Dropdown,
});

const csFilterGroup = (model: string, label: string, filters: MultiOption[]): MultiOption => ({
  model,
  label,
  selected: false,
  disabled: false,
  activeCount: 0,
  searchTerm: '',
  type: FilterType.Dropdown,
  options: filters,
});

const csGeneralDimensions: [string, string][] = [
  [ReportDimensions.Channel, 'Channel'],
  [ReportDimensions.SessionResult, 'Result'],
  [ReportDimensions.Moment, 'Moment'],
  [ReportDimensions.IdentificationStatus, 'Identification Status'],
  [ReportDimensions.SessionType, 'Session Type'],
  [ReportDimensions.Brand, 'Campaign Name'],
  [ReportDimensions.CRMName, 'CRM'],
];

export const csTrafficDimensions: [string, string][] = [
  [ReportDimensions.TrafficSource, 'Traffic Source (SRC)'],
  [ReportDimensions.SID1, 'Sub ID'],
  [ReportDimensions.SID2, 'Sub ID 2'],
  [ReportDimensions.SID3, 'Sub ID 3'],
];

export const csDeviceDimensions: [string, string][] = [
  [ReportDimensions.DeviceType, 'Device Type'],
  [ReportDimensions.OSName, 'Operating System'],
  [ReportDimensions.BrowserName, 'Browser'],
  [ReportDimensions.DeviceBrandFilter, 'Device Brand'],
];

export const CustomerSupportFields: MultiOptions = [
  csDimensionGroup('general', 'General', csGeneralDimensions),
  csDimensionGroup('traffic', 'Traffic', csTrafficDimensions),
  csDimensionGroup('device', 'Device', csDeviceDimensions),
];

export const CustomerSupportFilters: MultiOptions = [
  csFilterGroup('general', 'General', [
    csEnumFilter(ReportDimensions.Channel, 'Channel', SessionSourceLabels, StampedSessionSources),
    csFetchedFilter(ReportDimensions.SessionResult, 'Result'),
    csEnumFilter(ReportDimensions.Moment, 'Moment', MomentLabels),
    csEnumFilter(ReportDimensions.IdentificationStatus, 'Identification Status', IdentificationStatusLabels),
    csEnumFilter(ReportDimensions.SessionType, 'Session Type', SessionTypeLabels, SessionTypeValues),
    csFetchedFilter(ReportDimensions.Intent, 'Intent'),
    csFetchedFilter(ReportDimensions.CRMID, 'CRM'),
  ]),
  csFilterGroup('traffic', 'Traffic', csTrafficDimensions.map(([model, label]) => csFetchedFilter(model, label))),
  csFilterGroup('device', 'Device', csDeviceDimensions.map(([model, label]) => csFetchedFilter(model, label))),
];

export const customerSupportMetrics = [
  'session_count',
  'unique_sessions',
  'unique_customers',
  'automation_rate',
  'successful',
  'bypass',
  'dropoffs',
  'lifeline',
  'abandoned',
  'inquiries',
  'track_order_requests',
  'avg_visit_duration',
];

export const topIntentColumns: TopIntentColumnDef[] = [
  { key: TopIntentColumn.IntentName, label: 'Intent', sortable: false, isPercent: false, helpText: '' },
  {
    key: TopIntentColumn.SessionCount,
    label: 'Sessions',
    sortable: true,
    isPercent: false,
    helpText:
      'A visit is counted under every intent it selected, and visits that selected none are not listed. ' +
      'Intent sessions will therefore not add up to the Sessions total above.',
  },
  { key: TopIntentColumn.Share, label: '% of Total', sortable: true, isPercent: true, helpText: '' },
  { key: TopIntentColumn.AutomationRate, label: 'Automation Rate %', sortable: true, isPercent: true, helpText: '' },
];

export const portalMomentColumns: PortalMomentColumnDef[] = [
  { key: PortalMomentColumn.MomentName, label: 'Moment', sortable: false, isPercent: false, helpText: '' },
  {
    key: PortalMomentColumn.SessionCount,
    label: 'Sessions',
    sortable: true,
    isPercent: false,
    helpText: 'A visit is counted under its single active moment. Visits with no qualifying moment are not listed.',
  },
  { key: PortalMomentColumn.Share, label: '% of Total', sortable: true, isPercent: true, helpText: '' },
];

// ─── Customer Journey Report V3 ────────────────────────────────────────────────
export const customerJourneyColumns: string[] = ['session_id', 'session_started', 'item', 'outcome'];

// Intent of the report the Journey ID was clicked in; pre-selected in the Intent Type filter.
export const customerJourneyIntentByType: { [journeyType: string]: CustomerJourneyIntentType } = {
  [CustomerJourneyType.Order]: CustomerJourneyIntentType.Retention,
  [CustomerJourneyType.Subscription]: CustomerJourneyIntentType.Retention,
  [CustomerJourneyType.Return]: CustomerJourneyIntentType.Return,
};

export const customerJourneyRowDimensionGroups: CustomerJourneyDimensionGroup[] = [
  {
    key: 'session',
    label: 'Session',
    dimensions: [
      { key: 'parent_session_id', label: 'Parent Session', default: false },
      { key: 'channel', label: 'Channel', default: false },
      { key: 'support_contact', label: 'Support Contact', default: false },
      { key: 'session_outcome', label: 'Session Outcome', default: false },
    ],
  },
  {
    key: 'intent',
    label: 'Intent',
    dimensions: [
      { key: 'intent_type', label: 'Intent Type', default: false },
      { key: 'intent', label: 'Intent', default: false },
      { key: 'reason', label: 'Reason', default: false },
      { key: 'offer', label: 'Offer', default: false },
    ],
  },
];

export const customerJourneyRowDimensionKeys: string[] = [].concat(
  ...customerJourneyRowDimensionGroups.map((group) => group.dimensions.map((dimension) => dimension.key))
);

// Prefixed so the journey_options group keys can't collide with filter models listed in dimensionGroupModels.
export const customerJourneyDimensionGroupPrefix = 'journey_';
const resolveGeneralDimensions: [string, string][] = [
  [ReportDimensions.Campaign, 'Campaign'],
  [ReportDimensions.MerchantProfile, 'Merchant Profile'],
  [ReportDimensions.Outcome, 'Lookup Outcome'],
  [ReportDimensions.Moment, 'Moment'],
  [ReportDimensions.Product, 'Product'],
  [ReportDimensions.LinkType, 'Link Type'],
  [ReportDimensions.FirstIntent, 'First Intent'],
  [ReportDimensions.SessionResult, 'Session Result'],
  [ReportDimensions.CRM, 'CRM'],
  [ReportDimensions.OriginatorChannel, 'Originator Channel'],
];

export const resolveDeviceDimensions: [string, string][] = [
  [ReportDimensions.DeviceType, 'Device Type'],
  [ReportDimensions.OSName, 'Operating System'],
  [ReportDimensions.BrowserName, 'Browser'],
];

export const resolveStringFilterDimensions: ReportDimensions[] = [
  ReportDimensions.OriginatorChannel,
  ...csTrafficDimensions.map(([model]) => model as ReportDimensions),
  ...resolveDeviceDimensions.map(([model]) => model as ReportDimensions),
];

export const ResolveFields: MultiOptions = [
  csDimensionGroup('general', 'General', resolveGeneralDimensions),
  csDimensionGroup('traffic', 'Traffic', csTrafficDimensions),
  csDimensionGroup('device', 'Device', resolveDeviceDimensions),
];

export const ResolveFilters: MultiOptions = [
  csFilterGroup('general', 'General', [
    csFetchedFilter(ReportDimensions.Campaign, 'Campaign'),
    csFetchedFilter(ReportDimensions.MerchantProfile, 'Merchant Profile'),
    csEnumFilter(ReportDimensions.Outcome, 'Lookup Outcome', ResolveLookupOutcomeLabels),
    csEnumFilter(ReportDimensions.Moment, 'Moment', MomentLabels),
    csFetchedFilter(ReportDimensions.Product, 'Product'),
    enumStringFilter(ReportDimensions.LinkType, 'Link Type', ResolveLinkTypeLabels),
    csEnumFilter(ReportDimensions.SessionResult, 'Session Result', SessionResultLabels),
    csFetchedFilter(ReportDimensions.OriginatorChannel, 'Originator Channel'),
  ]),
  csFilterGroup('traffic', 'Traffic', csTrafficDimensions.map(([model, label]) => csFetchedFilter(model, label))),
  csFilterGroup('device', 'Device', resolveDeviceDimensions.map(([model, label]) => csFetchedFilter(model, label))),
];

export const resolveMetrics = [ReportDimensions.Sessions, ReportDimensions.Matched, ReportDimensions.LinkClicks];

export const resolveSummaryMetrics = [
  'lookups',
  'matched',
  'unmatched',
  'match_rate',
  'impressions',
  'clicks',
  'ctr',
];

export const resolveMomentColumns: PortalMomentColumnDef[] = [
  { key: PortalMomentColumn.MomentName, label: 'Moment', sortable: false, isPercent: false, helpText: '' },
  {
    key: PortalMomentColumn.SessionCount,
    label: 'Lookups',
    sortable: true,
    isPercent: false,
    helpText: 'Matched lookups grouped by the order state the receipt was served for. Lookups with no moment are not listed.',
  },
  { key: PortalMomentColumn.Share, label: '% of Matched', sortable: true, isPercent: true, helpText: '' },
];

export const resolveTopIntentColumns: TopIntentColumnDef[] = [
  { key: TopIntentColumn.IntentName, label: 'Intent', sortable: false, isPercent: false, helpText: '' },
  {
    key: TopIntentColumn.SessionCount,
    label: 'Sessions',
    sortable: true,
    isPercent: false,
    helpText: 'Opened sessions that clicked a step carrying that intent, counted once per session.',
  },
  { key: TopIntentColumn.Share, label: '% of Clicks', sortable: true, isPercent: true, helpText: '' },
];
